
import { defineComponent, computed } from "vue";
import type { PropType } from "vue";
import RichTextPanel from "../RichTextPanel/RichTextPanel.vue";
import { AccordionItemProps } from "../../../composables/types";

export default defineComponent({
  name: "AccordionPanel",
  components: {
    RichTextPanel,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    accordionItemsCollection: {
      type: Object as PropType<AccordionItemProps>,
      required: true,
    },
  },
  setup(props) {
    const accordionItems = computed(() => props.accordionItemsCollection.items);
    return {
      accordionItems,
    };
  },
});
